import { render } from "./apply.vue?vue&type=template&id=00b4e1c4&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"

import "./apply.vue?vue&type=style&index=0&id=00b4e1c4&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b4e1c4"]])

export default __exports__